export const pricingPlans = {
  monthly: [
    {
      id: 'starter',
      name: 'Starter',
      subtitle: 'Built for Your First Deals',
      price: 19,
      badge: null,
      disabled: false,
      billedText: null,
    },

    {
      id: 'pro',
      name: 'Pro',
      subtitle: 'Analyze More Deals, Faster',
      price: 79,
      badge: 'BEST VALUE',
      disabled: false,
      billedText: null,
    },

    {
      id: 'ultimate',
      name: 'Ultimate',
      subtitle: 'Scale Across Your Team',
      price: null,
      // He wrote the replacement character out: "$—" → "$-", "using a shorter dash".
      priceLabel: '-',
      unitLabel: '/annual plan only',
      badge: 'COMING SOON',
      disabled: true,
      billedText: null,
    },
  ],

  annual: [
    {
      id: 'starter',
      name: 'Starter',
      subtitle: 'Built for Your First Deals',
      price: 17,
      badge: null,
      disabled: false,
      billedText: 'Billed $204 annually · Save 10%',
    },

    {
      id: 'pro',
      name: 'Pro',
      subtitle: 'Analyze More Deals, Faster',
      price: 39,
      badge: 'BEST VALUE',
      disabled: false,
      billedText: 'Billed $474 annually · Save 50% with Founding Promo',
      // The advertised price already includes the promo — carry it into checkout.
      founding: true,
    },

    {
      id: 'ultimate',
      name: 'Ultimate',
      subtitle: 'Scale Across Your Team',
      price: null,
      // He wrote the replacement character out: "$—" → "$-", "using a shorter dash".
      priceLabel: '-',
      // M2.4: "/annual plan only" is redundant once the annual toggle is already on.
      unitLabel: null,
      badge: 'COMING SOON',
      disabled: true,
      billedText: null,
    },
  ],
}
